(() => {
  if (customElements.get('ochaya-subscription-choice')) return;
  class OchayaSubscriptionChoice extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const { signal } = this.abort;
      this.form = this.closest('form');
      this.plans = JSON.parse(this.querySelector('[data-subscription-plans]')?.textContent || '[]');
      this.planInput = this.querySelector('[data-selling-plan]');
      this.variants = JSON.parse(this.querySelector('[data-subscription-variants]').textContent);
      if (new URLSearchParams(window.location.search).get('purchase') === 'subscription') {
        this.querySelector('input[value="subscription"]').checked = true;
      }
      this.form.addEventListener('change', () => this.update(), { signal });
      const container = this.closest('.shopify-section') || document;
      container.addEventListener('variant:update', event => {
        if (String(event.detail?.data?.productId) !== this.dataset.productId) return;
        this.variant = this.variants.find(v => String(v.id) === String(event.detail.resource?.id));
        this.update();
      }, { signal });
      // Block preview subscriptions before the theme's delegated cart handler, including Enter/sticky submit.
      this.form.addEventListener('submit', event => {
        if (!this.isSubscription || this.canSubscribe) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.querySelector('[role="status"]').scrollIntoView?.({ block: 'center', behavior: 'smooth' });
      }, { capture: true, signal });
      this.variant = this.variants.find(v => String(v.id) === this.form.elements.id?.value);
      this.update();
      this.hidden = false;
    }
    disconnectedCallback() { this.abort?.abort(); }
    get isSubscription() { return this.querySelector('input[value="subscription"]').checked; }
    update() {
      const en = this.dataset.locale === 'en';
      const money = n => new Intl.NumberFormat(en ? 'en-NO' : 'nb-NO', { style: 'currency', currency: this.dataset.currency }).format(n / 100);
      const selected = this.isSubscription;
      this.querySelector('.ochaya-subscription__details').hidden = !selected;
      this.querySelector('input[value="subscription"]').setAttribute('aria-expanded', String(selected));
      const price = this.variant?.price;
      this.querySelector('[data-once-price]').textContent = price == null ? '—' : money(price);

      const months = Number(this.querySelector('select').value);
      const checkoutEnabled = ['qa', 'production'].includes(this.dataset.mode);
      const plans = this.plans.filter(p => p.months === months && /^[1-9]\d*$/.test(String(p.id)));
      const plan = plans.length === 1 ? plans[0] : null;
      const allocations = plan ? this.variant?.allocations?.filter(a => String(a.id) === String(plan.id)) || [] : [];
      const allocation = allocations.length === 1 && Number.isSafeInteger(allocations[0].price) && allocations[0].price >= 0 ? allocations[0] : null;
      this.canSubscribe = checkoutEnabled && !!this.planInput && !!allocation && !!this.variant?.available;
      if (this.planInput) {
        this.planInput.disabled = !selected || !this.canSubscribe;
        this.planInput.value = this.canSubscribe ? String(plan.id) : '';
      }
      const recurringPrice = checkoutEnabled ? allocation?.price : price == null ? null : Math.round(price * .85);
      this.querySelector('[data-subscription-price]').textContent = recurringPrice == null ? '—' : money(recurringPrice);
      const quantity = Number(this.form.elements.quantity?.value || 1);
      this.querySelector('[data-subscription-summary]').textContent = recurringPrice == null ? '' : en
        ? `${money(recurringPrice * quantity)} per delivery, every ${months === 1 ? 'month' : months + ' months'}. Shipping calculated at checkout.`
        : `${money(recurringPrice * quantity)} per levering, ${months === 1 ? 'hver måned' : months === 2 ? 'annenhver måned' : 'hver tredje måned'}. Frakt beregnes i kassen.`;
      // Enabled checkout uses Shopify allocations; previews cannot submit a plan.
      this.form.dataset.ochayaSubscriptionPreview = String(selected);
      this.form.querySelectorAll('[name="add"]').forEach(button => {
        button.disabled = (selected && !this.canSubscribe) || !this.variant?.available;
      });
      this.form.querySelectorAll('[ref="acceleratedCheckoutButtonContainer"]').forEach(el => { el.hidden = selected; });
      this.form.querySelectorAll('quantity-discount-offer').forEach(el => { el.hidden = selected; });
    }
  }
  customElements.define('ochaya-subscription-choice', OchayaSubscriptionChoice);
})();
